export default "__VITE_ASSET__BiH1uAKM__"